// This file supposed to be an axios + axios mock adapter, but after we did get rid of it and used usual get requests
import axios from 'axios';
export default axios;
